import qs from 'qs'
import Toast from '@roo/roo/Toast'
import { i18nClient } from '@sailor/i18n-web'
import {
  getI18nParams, isLocal, toSSOLogin,
} from '../utils'
import {
  LOGIN_ERROR_CODES,
  LOGIN_ERROR_TOAST_EXIT_CODES,
} from '../constants/apiCode'


const failToast = (message, duration = 3500, extraProps = {}) =>
  Toast.open({
    duration,
    theme: 'light',
    position: 'center',
    status: 'fail',
    children: message,
    ...extraProps,
  })

// interceptors.request.use
// 请求拦截器：国际化请求头，i18n必须接入
export function addI18nHeader (config) {
  return { ...config, headers: { ...config.headers, ...getI18nParams() } }
}

// 请求拦截器：formdata处理
export function injectFormDataFormat (config) {
  const { data } = config
  return { ...config, data: qs.stringify(data) }
}

// interceptors.response.use
// 响应拦截器：登录信息校验统一拦截器，需要登录后才可请求的接口必须接入
export function loginCheck (response) {
  const { status, data, config } = response
  const requestHeaders = config?.headers
  const { code, msg, message } = data
  try {
    // const isLoc = isLocal(window.location.host)
    // if (isLoc) return response
    // 直接跳登录
    if (LOGIN_ERROR_CODES.indexOf(+code) !== -1) {
      console.log('LOGIN_ERROR_CODES', +code)
      failToast(i18nClient.getText('d_partner_login_text') || 'Please Login', 3500, { maxCount: 1, position: 'topCenter' })
      toSSOLogin()
    }
    return response
  } catch (e) {
    console.log(e)
    return response
  }
}

// 响应拦截器：接口错误吗处理拦截器，0成功，其他为失败，可选接入
export function codeCheck (response) {
  const { data, config } = response
  const { code, msg, message, data: realData } = data
  const {
    autoToast = true, // 是否显示Toast
    url = '',
  } = config || {}
  // 非0码弹窗报错，排除登录、越权码
  if (code !== 0 && [...LOGIN_ERROR_CODES].indexOf(+code) === -1) {
    autoToast && failToast(msg || message || 'api error', 3500, { maxCount: 1, position: 'topCenter' })
    // throw new Error(`${errorName}, ${msg || message || 'api code not 0 error'}, API: ${(url || '').replace(/\?.*$/, '')}`)
  }
  return realData
}

// 响应拦截器：返回数据处理拦截器，可选接入
export function returnAllData (response) {
  const { data } = response
  return data
}
